
/**
 * Use this class to process data for smart points
 */
export default class SmartPointModelDTO {
  id = ''
  name = ''
  address = ''
  country = ''
  latitude = null
  longitude = null
  postalCode = null
  city = ''
  image = ''
  note = ''
  title = ''
  type = ''
  email = ''
  workingHours = ''
  phone = ''

  constructor (
    id = '',
    name = '',
    address = '',
    country = '',
    latitude = null,
    longitude = null,
    postalCode = null,
    city = '',
    image = '',
    note = '',
    title = '',
    type = '',
    email = '',
    workingHours = '',
    phone = ''
  ) {
    this.id = id
    this.name = name
    this.address = address
    this.country = country
    this.latitude = Number(latitude)
    this.longitude = Number(longitude)
    this.postalCode = Number(postalCode)
    this.city = city
    this.image = image
    this.note = note
    this.title = title
    this.type = type
    this.email = email
    this.workingHours = workingHours
    this.phone = phone
  }
}
